import { IPaging, IQueryParameters } from 'common/models';
import { ICustomFilters } from 'modules/_common/models';
import API from 'services/api';

interface IProps extends IPaging, IQueryParameters {}

export const getCustomFilter = ({ params }: IProps): Promise<ICustomFilters[]> =>
  API.get('/api/users/filters', { params })?.then(response => response?.data);
